module.exports = __webpack_public_path__ + "static/media/4.6e6bdba4.png";